
import Vue from 'vue'
import dayjs from 'dayjs'

interface Language {
	code: string
	name: string
}

export default Vue.extend({
	name: 'AppHeader',
	data() {
		return {
			dropdownOpen: false,
			languages: [
				{ code: 'it', name: 'Italiano' },
				{ code: 'en', name: 'English' },
				{ code: 'es', name: 'Español' },
				{ code: 'fr', name: 'Français' },
				{ code: 'de', name: 'Deutsch' },
				{ code: 'pt', name: 'Português' }
			] as Language[]
		}
	},
	computed: {
		currentLang(): string {
			return this.$i18n.locale
		},
		currentLanguage(): Language {
			return this.languages.find((lang: Language) => lang.code === this.currentLang) || this.languages[0]
		}
	},
	mounted() {
		// Sync dayjs locale with initial i18n locale (from URL or browser)
		dayjs.locale(this.$i18n.locale)
	},
	methods: {
		toggleDropdown() {
			this.dropdownOpen = !this.dropdownOpen
		},
		closeDropdown() {
			this.dropdownOpen = false
		},
		changeLanguage(langCode: string) {
			this.$i18n.locale = langCode
			// Sync dayjs locale with i18n locale
			dayjs.locale(langCode)
			// Emit event to notify other components about language change
			this.$root.$emit('language-changed', langCode)
			this.closeDropdown()
		}
	},
	directives: {
		'click-outside': {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			bind(el: any, binding: any) {
				el.clickOutsideEvent = (event: Event) => {
					if (!(el === event.target || el.contains(event.target))) {
						binding.value()
					}
				}
				document.addEventListener('click', el.clickOutsideEvent)
			},
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			unbind(el: any) {
				document.removeEventListener('click', el.clickOutsideEvent)
			}
		}
	}
})
